import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { TooltipModule } from 'primeng/tooltip';
import { AgentChatComponent } from '../shared/components/agent-chat/agent-chat.component';

interface AppNavItem extends MenuItem {
  iconSrc?: string;
}

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TooltipModule,
    AgentChatComponent,
  ],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent {
  private readonly _router = inject(Router);

  menuItems: AppNavItem[] = [];
  isCollapsed = signal(true);

  constructor() {
    this.menuItems = [
      {
        label: 'Executive Summary',
        icon: 'pi pi-th-large',
        routerLink: '/executive-summary'
      },
      {
        label: 'HSE Report',
        icon: 'pi pi-shield',
        routerLink: '/hse-report'
      },
      {
        label: 'Operations Overview',
        icon: 'pi pi-chart-line',
        routerLink: '/operations-overview'
      },
      {
        label: 'Databricks',
        iconSrc: 'assets/databricks-icon.svg',
        routerLink: '/databricks'
      },
      {
        label: 'Genie',
        iconSrc: 'assets/genie-icon.svg',
        routerLink: '/genie'
      },
    ];
  }

  toggleMenu(): void {
    this.isCollapsed.update(v => !v);
  }

  showChat(): boolean {
    return !this._router.url.startsWith('/databricks') && !this._router.url.startsWith('/genie');
  }
}